/**
 * 原料管理库存管理模块
 */
 import axios from '../request';
 export default{
    

    /**
     * 原料管理库存管理
     */
    // 查询库存管理列表信息
    searchMaterialStockList: params =>
        axios.post(`/materials/chainInventory/findList?pageNum=${params.pageNum}&pageSize=${params.pageSize}`, params),
    // 添加或修改库存管理信息
    insertChainProjectOrUpdate: params =>
        axios.post('/materials/chainInventoryRecord/add', params),
    // 库存管理信息详情
    detailsChainProject: params =>

        axios.post('/materials/', params),
    // 删除库存管理信息
    deleteChainProject: params =>
        axios.post('/materials/', params),
    

    /**
     * 校正记录
     */
    // 查询校正记录列表信息
    searchMaterialRecordList: params =>
        axios.post(`/materials/chainInventoryRecord/findList?pageNum=${params.pageNum}&pageSize=${params.pageSize}`, params),

    //导出数据
    exportCheckRecordDatas:params=>
        axios({
            method: 'post',
            url: '/materials/chainInventoryRecord/exportCorrection',
            responseType: 'blob',
            data: params
        }),

 //出库
 searchOutRecordList: params =>
        axios.post(`/materials/chainInventoryRecord/findList?pageNum=${params.pageNum}&pageSize=${params.pageSize}`, params),
    
    /**
     * 入库/记录
     */
    // 查看入库记录列表 
    searchInRecordList: params =>
        axios.post(`/materials/chainWarehousing/findList?pageNum=${params.pageNum}&pageSize=${params.pageSize}`, params),
    // 新增/修改入库记录
    insertMaterialInRecordList: params =>
        axios.post('/materials/chainWarehousing/addOrUpdate', params),
    // 新增/修改入库记录
    deleteInRecordList: params =>
        axios.post('/materials/chainWarehousing/delete', params),
    //导出数据
    exportInRecordDatas:params=>
        axios({
            method: 'post',
            url: '/materials/chainWarehousing/exportWarehousing',
            responseType: 'blob',
            data: params
        }),
    /**
     * 消耗记录
     */
    // 查询消耗记录列表信息
    searchMaterialOutList: params =>
        axios.post('/materials/', params),
    //导出数据
    exportOutRecordDatas:params=>
        axios({
            method: 'post',
            url: '/materials/chainInventoryRecord/exportConsumption',
            responseType: 'blob',
            data: params
        }),

 }